import React from 'react';

export const AppLogoSvg = ({size, ...props}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 475.1 475.1"
        width={size}
        height={size}
        {...props}>
        <path
            fill="#d1392a"
            d="M409.3 472.1c-25.3 28.7-280.8 28.5-306.5 0s101-171.7 152.1-171.7 179.8 143 154.4 171.7z"
            data-name="path11-1"
            transform="translate(-18.4 -18.5)"
        />
        <path
            fill="#2facc4"
            d="M39.9 102.7c28.7-25.4 171.7 103.2 171.7 154.4S68.4 435 39.9 409.2s-28.7-281.2 0-306.5z"
            data-name="path11-1"
            transform="translate(-18.4 -18.5)"
        />
        <path
            fill="#6f9e33"
            d="M472.1 102.7c28.7 25.3 28.5 280.8 0 306.5s-171.7-101-171.7-152.1 143-179.8 171.7-154.4z"
            data-name="path11-1"
            transform="translate(-18.4 -18.5)"
        />
        <path
            fill="#efb301"
            d="M409.3 39.9c25.4 28.7-103.2 171.7-154.4 171.7S77 68.4 102.8 39.9s281.2-28.7 306.5 0z"
            data-name="path11-1"
            transform="translate(-18.4 -18.5)"
        />
        <path
            fill="#fff"
            d="M265.1 404.8h-18.2a5.2 5.2 0 01-5.2-5.2V112.4a5.2 5.2 0 015.2-5.2h18.2a5.2 5.2 0 015.2 5.2v287.2a5.2 5.2 0 01-5.2 5.2z"
            transform="translate(-18.4 -18.5)"
        />
        <path
            fill="#fff"
            d="M404.8 246.9v18.2a5.2 5.2 0 01-5.2 5.2H112.4a5.2 5.2 0 01-5.2-5.2v-18.2a5.2 5.2 0 015.2-5.2h287.2a5.2 5.2 0 015.2 5.2z"
            transform="translate(-18.4 -18.5)"
        />
    </svg>
);

export const AppLogoSvgGray = ({size = 16, ...props}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 475.1 475.1"
        width={size}
        height={size}
        style={{fillOpacity: 0.5}}
        {...props}>
        <g opacity="0.2">
            <path
                fill="#fff"
                d="M488.3 158.1c-3.2-21.6-7.4-38.1-13.3-52-13.1-30.7-44.4-60.5-78-73.2-17.7-6.7-48.5-10.4-70.8-11.9L256 18.4 185.8 21c-22.3 1.5-53.1 5.2-70.8 11.9-33.5 12.7-64.9 42.5-78 73.2-5.9 13.9-10.1 23.9-13.3 52L18.5 256l5.2 97.9c4.5 31.1 7.4 38.1 13.3 52 13.1 30.7 44.5 60.5 78 73.2 17.7 6.7 48.5 10.4 70.8 11.9l70.2 2.6 70.2-2.6c22.3-1.5 53.1-5.2 70.8-11.9 33.6-12.7 64.9-42.5 78-73.2 5.9-13.9 10.5-32.3 13.3-52l5.2-97.9z"
                transform="translate(-18.4 -18.4)"
            />
            <path
                fill="#d1392a"
                d="M409.3 472.1c-25.3 28.7-280.8 28.5-306.5 0s101-171.7 152.1-171.7 179.8 143 154.4 171.7z"
                data-name="path11-1"
                transform="translate(-18.4 -18.4)"
            />
            <path
                fill="#2facc4"
                d="M39.9 102.7C68.6 77.3 211.6 206 211.6 257.1S68.4 435 39.9 409.2s-28.7-281.2 0-306.5z"
                data-name="path11-1"
                transform="translate(-18.4 -18.4)"
            />
            <path
                fill="#6f9e33"
                d="M472.1 102.7c28.7 25.4 28.5 280.8 0 306.5s-171.7-101-171.7-152.1 143-179.8 171.7-154.4z"
                data-name="path11-1"
                transform="translate(-18.4 -18.4)"
            />
            <path
                fill="#efb301"
                d="M409.3 39.9c25.4 28.7-103.2 171.7-154.4 171.7S77 68.4 102.8 39.9s281.2-28.7 306.5 0z"
                data-name="path11-1"
                transform="translate(-18.4 -18.4)"
            />
            <path
                fill="#fff"
                d="M265.1 404.8h-18.2a5.2 5.2 0 01-5.2-5.2V112.4a5.2 5.2 0 015.2-5.2h18.2a5.2 5.2 0 015.2 5.2v287.2a5.2 5.2 0 01-5.2 5.2z"
                transform="translate(-18.4 -18.4)"
            />
            <path
                fill="#fff"
                d="M404.8 246.9v18.2a5.2 5.2 0 01-5.2 5.2H112.4a5.2 5.2 0 01-5.2-5.2v-18.2a5.2 5.2 0 015.2-5.2h287.2a5.2 5.2 0 015.2 5.2z"
                transform="translate(-18.4 -18.4)"
            />
        </g>
    </svg>
);